export default __webpack_public_path__ + "static/media/ff-seguros-logo.a7614eae.png";